import { SET_LISTAS_DE_COMPRA } from "./ActionTypes";

export const setListasDeCompra = (listasDeCompra) => ({
  type: SET_LISTAS_DE_COMPRA,
  listasDeCompra,
});
